// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DonateModal_modal__hiPRH{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 400;
}
.DonateModal_container__oTe4X{
    position: relative;
    height: 90%;
    width: 85%;
    max-width: 412px;
    padding: 20px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.DonateModal_donated__9lIGX{
    height: auto !important;
}
.DonateModal_header__T-SVj{
    margin-bottom: 8px;
    color: #1F363D;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.DonateModal_close__R5WKg{
    position: absolute;
    top: 28px;
    right: 33px;
    height: 12px;
    width: 12px;
    cursor: pointer;
}
.DonateModal_form__sQhmn{
    height: calc(100% - 50px);
}
.DonateModal_formInputs__bE3MY{
    height: calc(100% - 138px);
    padding-left: 4px;
    padding-right: 4px;
    overflow-y: auto;
    overflow-x: hidden;
}
.DonateModal_amountInput__8Rg-6{
    display: block !important;
    margin-top: 25px;
    margin-bottom: 15px;
}
.DonateModal_amountInput__8Rg-6 input{
    width: calc(100% - 86px);
    font-family: 'Gotham Medium', serif;
    font-size: 22px;
    border: 6px solid #40798C66;
}
.DonateModal_amountInput__8Rg-6 input:focus{
    border: 6px solid #40798C66;
}
.DonateModal_tipSlider__\\+AJLn{
    margin-top: 10px;
    margin-bottom: 35px;
}
.DonateModal_input__vAk99{
    display: block !important;
    margin-top: 20px;
}
.DonateModal_input__vAk99 input{
    width: calc(100% - 44px);
}
.DonateModal_textEditor__hZSVi{
    display: block !important;
    height: 126px;
    margin-top: 20px;
}
.DonateModal_textEditor__hZSVi textarea{
    width: calc(100% - 48px);
}
.DonateModal_buttons__zF3aV{
    margin-top: 35px;
}
.DonateModal_buttonsApiError__KX9sc{
    margin-top: 9px;
}
.DonateModal_button__YRaeU{
    display: block;
    width: 100%;
    margin-top: 10px;
}
.DonateModal_coinJar__dKwLt{
    display: block;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    height: 40px;
    width: 40px;
    margin-top: 25px;
}
.DonateModal_donatedHeader__j8S10{
    margin-top: 20px;
    color: #40798C;
    text-align: center;
    font-family: 'Gotham Bold', serif;
    font-size: 16px;
}
.DonateModal_donatedText__1ZEOe{
    margin-top: 15px;
    color: #1F363D;
    text-align: center;
    font-size: 14px;
}
.DonateModal_donatedAmount__9dKfO, .DonateModal_donatedOrganization__oV5hL{
    font-family: 'Gotham Bold', serif;
}
.DonateModal_donatedButton__2vzPI{
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    margin-top: 25px;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/DonateModal.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,mCAAmC;IACnC,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB","sourcesContent":[".modal{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 400;\n}\n.container{\n    position: relative;\n    height: 90%;\n    width: 85%;\n    max-width: 412px;\n    padding: 20px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.donated{\n    height: auto !important;\n}\n.header{\n    margin-bottom: 8px;\n    color: #1F363D;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.close{\n    position: absolute;\n    top: 28px;\n    right: 33px;\n    height: 12px;\n    width: 12px;\n    cursor: pointer;\n}\n.form{\n    height: calc(100% - 50px);\n}\n.formInputs{\n    height: calc(100% - 138px);\n    padding-left: 4px;\n    padding-right: 4px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n.amountInput{\n    display: block !important;\n    margin-top: 25px;\n    margin-bottom: 15px;\n}\n.amountInput input{\n    width: calc(100% - 86px);\n    font-family: 'Gotham Medium', serif;\n    font-size: 22px;\n    border: 6px solid #40798C66;\n}\n.amountInput input:focus{\n    border: 6px solid #40798C66;\n}\n.tipSlider{\n    margin-top: 10px;\n    margin-bottom: 35px;\n}\n.input{\n    display: block !important;\n    margin-top: 20px;\n}\n.input input{\n    width: calc(100% - 44px);\n}\n.textEditor{\n    display: block !important;\n    height: 126px;\n    margin-top: 20px;\n}\n.textEditor textarea{\n    width: calc(100% - 48px);\n}\n.buttons{\n    margin-top: 35px;\n}\n.buttonsApiError{\n    margin-top: 9px;\n}\n.button{\n    display: block;\n    width: 100%;\n    margin-top: 10px;\n}\n.coinJar{\n    display: block;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    height: 40px;\n    width: 40px;\n    margin-top: 25px;\n}\n.donatedHeader{\n    margin-top: 20px;\n    color: #40798C;\n    text-align: center;\n    font-family: 'Gotham Bold', serif;\n    font-size: 16px;\n}\n.donatedText{\n    margin-top: 15px;\n    color: #1F363D;\n    text-align: center;\n    font-size: 14px;\n}\n.donatedAmount, .donatedOrganization{\n    font-family: 'Gotham Bold', serif;\n}\n.donatedButton{\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    margin-top: 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `DonateModal_modal__hiPRH`,
	"container": `DonateModal_container__oTe4X`,
	"donated": `DonateModal_donated__9lIGX`,
	"header": `DonateModal_header__T-SVj`,
	"close": `DonateModal_close__R5WKg`,
	"form": `DonateModal_form__sQhmn`,
	"formInputs": `DonateModal_formInputs__bE3MY`,
	"amountInput": `DonateModal_amountInput__8Rg-6`,
	"tipSlider": `DonateModal_tipSlider__+AJLn`,
	"input": `DonateModal_input__vAk99`,
	"textEditor": `DonateModal_textEditor__hZSVi`,
	"buttons": `DonateModal_buttons__zF3aV`,
	"buttonsApiError": `DonateModal_buttonsApiError__KX9sc`,
	"button": `DonateModal_button__YRaeU`,
	"coinJar": `DonateModal_coinJar__dKwLt`,
	"donatedHeader": `DonateModal_donatedHeader__j8S10`,
	"donatedText": `DonateModal_donatedText__1ZEOe`,
	"donatedAmount": `DonateModal_donatedAmount__9dKfO`,
	"donatedOrganization": `DonateModal_donatedOrganization__oV5hL`,
	"donatedButton": `DonateModal_donatedButton__2vzPI`
};
export default ___CSS_LOADER_EXPORT___;
